module.exports = __webpack_public_path__ + "media/images/p-about/partner/龍谷大学-d91eba6b1572a1cc4a8adddfacd71942.jpg";